import { render, staticRenderFns } from "./HumanHandover.vue?vue&type=template&id=47a86e66&"
import script from "./HumanHandover.vue?vue&type=script&lang=js&"
export * from "./HumanHandover.vue?vue&type=script&lang=js&"
import style0 from "./HumanHandover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports